export const resourceTypeSearchParams = "rt";
